import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { withStyles } from "@material-ui/core";
import { useStyles } from "./SessionExpiredDialog.css";

class SessionExpiredDialog extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Dialog open={true} onClose={this.props.logout}>
        <DialogTitle>Session Expired! Login Again.</DialogTitle>
        <DialogActions>
          <Button
            disableRipple
            onClick={this.props.logout}
            className={classes.buttonStyle}
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(useStyles)(SessionExpiredDialog);
